import { Injectable } from '@angular/core';
import { Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from "./auth.service";
import {hasAnyRole} from "../model/user";
import {map, take, tap} from "rxjs/operators";
import {loggedIn} from "@angular/fire/auth-guard";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private auth: AuthService,
    private router: Router,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.auth.user$.pipe(
      take(1),
      map(user => {
        // An account can hold several roles, so the route asks whether any of
        // the ones it wants is among them — not whether the single primary
        // role happens to match.
        return !!user && (!route.data.roles || hasAnyRole(user, route.data.roles));
      }),
      tap(authorized => {
        if(!authorized) {
          console.log("access denied");
          this.router.navigate(['/']);
        }
      })
    );
  }
}
